module.exports = __webpack_public_path__ + "img/jydwx.eb8d9828.jpg";